export default __webpack_public_path__ + "static/media/oeo-logo.309a4aad.png";